export const blockIconsAudioandvideoMusicNoteNew = (
	<span className='material-symbols-outlined'>music_note</span>
);
